module.exports = __webpack_public_path__ + "static/gatsby-astronaut-svg-635851728b61882f8cf645007d077bb8.svg";